<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :visible.sync="manageCustomerTplVisible"
            custom-class="custom-form-dialog manage-customer-tpl-dialog"
            title="管理客户"
            width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <CustomFormPc
                    v-if="dataLoaded"
                    ref="customFormPc"
                    :field_list="formInfoList"
                    @submit-form="summitFormData"
            />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import {getFormFields, CustomerManageAdd} from "@/api";
    import CustomFormPc from "@/components/pComponents/CustomFormPc";

    export default {
        name: "ManageCustomerTpl",
        components: {CustomFormPc},
        props: {
            manageCustomerTplVisible: {
                type: Boolean,
                default: false,
            },
            customer_id: "",
        },
        data() {
            return {
                loading: false,
                formInfoList: [],
                btnDisabled: false,
                dataLoaded: false,
            };
        },
        created() {
            this._getFromFields();
        },
        methods: {
            _getFromFields() {
                this.loading = true;
                getFormFields({
                    field_form: "customer_manages",
                })
                        .then((res) => {
                            if (res.code === 200) {
                                this.formInfoList = res.data;
                                this.dataLoaded = true;
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
            },
            handleDialogClose() {
                this.$emit("update:manageCustomerTplVisible", false);
            },
            handleDialogConfirm() {
                this.$refs.customFormPc.handleClickPublish();
            },
            summitFormData(customForm) {
                if (customForm) {
                    this.btnDisabled = true;
                    this.loading = true;
                    const form = {
                        customer_id: this.customer_id,
                        ...customForm,
                    };
                    CustomerManageAdd(form)
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message);
                                    this.$emit("update:manageCustomerTplVisible", false);
                                    this.$emit("createCallback");
                                } else {
                                    this.$message.error(res.message);
                                }
                                this.btnDisabled = false;
                                this.loading = false;
                            })
                            .catch(() => {
                                this.btnDisabled = false;
                                this.loading = false;
                            });
                }
            },
        },
    };
</script>
<style lang="scss">
    .manage-customer-tpl-dialog {
        .el-dialog__body {
            padding: 0;

            & > div {
                min-height: 250px;
                padding: 24px;
            }
        }
    }
</style>
